var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group select2-input-container" }, [
    _c("select", { ref: "select2", staticClass: "form-control input-sm" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }